module.exports = __webpack_public_path__ + "static/appGroup-df2724db1ba75e8140a0b91c06437e8e.png";